// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1vIDy","label":"LabeledBox_label__3jE_O"};